import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len */
var Icon = function Icon() {
  return /*#__PURE__*/_jsxs("svg", {
    height: "12",
    viewBox: "0 0 14 12",
    width: "14",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Link Icon"
    }), /*#__PURE__*/_jsx("path", {
      "aria-hidden": "true",
      d: "m13.3 2.4c-.4-.6-.9-1.1-1.6-1.3s-1.4-.1-2.1.3l-1.4.8c-.6.4-1.1.9-1.2 1.6-.2.6-.2 1.1 0 1.6l-.5.3c-.3-.5-.8-.8-1.4-.9-.6-.2-1.4-.1-2 .2l-1.4.9c-1.3.7-1.7 2.3-1 3.6.5.9 1.4 1.3 2.3 1.3.5 0 .9-.1 1.3-.4l1.4-.8c.7-.3 1.2-.9 1.3-1.5.2-.6.2-1.1 0-1.6l.5-.3c.5.7 1.3 1 2.1 1 .5 0 .9-.1 1.3-.4l1.4-.8c1.3-.7 1.7-2.4 1-3.6zm-7.6 5.3c-.1.3-.3.6-.6.8l-1.4.8c-.6.4-1.5.2-1.8-.5-.4-.6-.2-1.4.5-1.8l1.4-.8c.3-.2.7-.2 1-.1.2 0 .4.1.5.3l-2.3 1.2c-.2.2-.3.4-.2.6.1.1.2.2.4.2.1 0 .1 0 .2-.1l2.3-1.3c.1.3.1.5 0 .7zm6.6-3.6c-.1.3-.3.6-.6.8l-1.4.8c-.6.3-1.2.2-1.6-.2l2.3-1.3c.2-.1.3-.4.2-.6s-.4-.3-.6-.2l-2.4 1.3c0-.2 0-.4 0-.5.1-.3.3-.6.6-.8l1.4-.8c.3-.2.7-.2 1-.1.5 0 .8.2.9.5.2.3.3.7.2 1.1z"
    })]
  });
};

export default Icon;